"use client";

export const uz = {
  // Header
  "nav.services": "Xizmatlar",
  "nav.about": "Biz haqimizda",
  "nav.team": "Jamoa",
  "nav.gallery": "Galereya",
  "nav.reviews": "Sharhlar",
  "nav.contacts": "Kontaktlar",
  "nav.login": "Kirish",
  "nav.dashboard": "Kabinet",

  // Hero
  "hero.badge": "Uy hayvonlaringiz uchun g'amxo'rlik",
  "hero.title": "To'liq tsiklli veterinariya klinikasi",
  "hero.subtitle": "Zamonaviy jihozlar, tajribali shifokorlar va har bir bemorga individual yondashuv",
  "hero.appointment": "Qabulga yozilish",
  "hero.services": "Bizning xizmatlar",
  "hero.stats.experience": "Yillik tajriba",
  "hero.stats.clients": "Mamnun mijozlar",
  "hero.stats.support": "Kuniga 24 soat",

  // Services
  "services.title": "Bizning xizmatlar",
  "services.subtitle": "Uy hayvonlaringiz uchun to'liq veterinariya xizmatlari",
  "services.consultation": "Konsultatsiyalar",
  "services.consultation.desc": "Tajribali veterinarlarning professional maslahatlari",
  "services.surgery": "Jarrohlik",
  "services.surgery.desc": "Har qanday murakkablikdagi rejalashtirilgan va shoshilinch operatsiyalar",
  "services.diagnostics": "Diagnostika",
  "services.diagnostics.desc": "Aniq diagnostika uchun zamonaviy jihozlar",
  "services.vaccination": "Emlash",
  "services.vaccination.desc": "Emlash va profilaktikaning to'liq kompleksi",
  "services.hospitalization": "Statsionar",
  "services.hospitalization.desc": "Kuniga 24 soat parvarish va nazorat",
  "services.grooming": "Gruming",
  "services.grooming.desc": "Professional parvarish va gigiena",

  // About
  "about.title": "Klinikamiz haqida",
  "about.subtitle": "Biz 2008 yildan beri ishlaymiz va minglab hayvonlarga yordam berdik",
  "about.mission": "Bizning missiyamiz",
  "about.mission.text": "Zamonaviy texnologiyalardan foydalanib va har bir bemorga individual yondashuvni qo'llab, sifatli veterinariya yordamini taqdim etish.",
  "about.values": "Bizning qadriyatlarimiz",
  "about.values.text": "Professionallik, g'amxo'rlik, halollik va hayvonlarga muhabbat - ishimizning asosi.",
  "about.equipment": "Jihozlar",
  "about.equipment.text": "Yevropa sifatidagi zamonaviy diagnostika va jarrohlik jihozlari.",

  // Team
  "team.title": "Bizning jamoa",
  "team.subtitle": "Hayvonlarga muhabbat bilan tajribali mutaxassislar",
  "team.experience": "yillik tajriba",
  "team.position.head": "Bosh shifokor",
  "team.position.surgeon": "Jarroh",
  "team.position.therapist": "Terapevt",
  "team.position.nurse": "Katta hamshira",

  // Gallery
  "gallery.title": "Bizning klinika",
  "gallery.subtitle": "Zamonaviy jihozlar va qulay atmosfera",
  "gallery.reception": "Qabulxona",
  "gallery.surgery": "Operatsiya xonasi",
  "gallery.ward": "Palata",
  "gallery.diagnostics": "Diagnostika xonasi",

  // Reviews
  "reviews.title": "Mijozlarimizning sharhlari",
  "reviews.subtitle": "Uy hayvonlari egalari biz haqimizda nima deyishadi",

  // FAQ
  "faq.title": "Tez-tez beriladigan savollar",
  "faq.subtitle": "Mashhur savollarga javoblar",
  "faq.q1": "Qabulga qanday yozilish mumkin?",
  "faq.a1": "Bizning sayt orqali, telefon yoki Telegram-bot orqali yozilishingiz mumkin.",
  "faq.q2": "Siz kuniga 24 soat ishlaysizmi?",
  "faq.a2": "Ha, bizning klinika 24/7 ishlaydi. Shoshilinch yordam istalgan vaqtda mavjud.",
  "faq.q3": "Qanday to'lov usullarini qabul qilasiz?",
  "faq.a3": "Biz naqd pul, kartalar va elektron to'lovlarni qabul qilamiz.",
  "faq.q4": "Oldindan yozilish kerakmi?",
  "faq.a4": "Rejalashtirilgan qabullar uchun oldindan yozilishni tavsiya qilamiz. Shoshilinch holatlarni yozilmasdan qabul qilamiz.",

  // Contact
  "contact.title": "Kontaktlar",
  "contact.subtitle": "Biz bilan qulay usulda bog'laning",
  "contact.address": "Manzil",
  "contact.phone": "Telefon",
  "contact.email": "Email",
  "contact.schedule": "Ish vaqti",
  "contact.schedule.text": "Kuniga 24 soat, dam olish kunlarisiz",
  
  // Contact Form
  "contacts.form.title": "Bizga yozing",
  "contacts.form.subtitle": "Kontaktlaringizni qoldiring va biz siz bilan bog'lanamiz",
  "contacts.form.phone": "Telefon",
  "contacts.form.phoneHelper": "Format: +998-XX-XXX-XX-XX",
  "contacts.form.phoneInvalid": "Iltimos, telefon raqamini +998-XX-XXX-XX-XX formatida kiriting",
  "contacts.form.fullName": "Ism Familiya",
  "contacts.form.fullNamePlaceholder": "Ivanov Ivan",
    "contacts.form.firstName": "Ism",
    "contacts.form.firstNamePlaceholder": "John",
    "contacts.form.lastName": "Familiya",
    "contacts.form.lastNamePlaceholder": "Doe",
  "contacts.form.message": "Xabar (ixtiyoriy)",
  "contacts.form.messagePlaceholder": "Xabaringiz yoki savolingizni yozing...",
  "contacts.form.messageHelper": "Minimal 5 ta belgi, maksimal 2000",
  "contacts.form.submit": "Yuborish",
  "contacts.form.sending": "Yuborilmoqda...",
  "contacts.form.success": "Rahmat!",
  "contacts.form.successDesc": "Tez orada siz bilan bog'lanamiz",
  "contacts.form.error": "Xato",
  "contacts.form.invalidPhone": "Telefon raqami xalqaro formatda bo'lishi kerak: +[mamlakat kodi][raqam] (masalan, +12345678901)",
  "contacts.form.invalidName": "Ism faqat harflar, bo'shliqlar va defislardan iborat bo'lishi kerak (2-64 ta belgi)",

  // Footer
  "footer.about": "Klinika haqida",
  "footer.about.text": "Zamonaviy jihozlar va tajribali mutaxassislarga ega veterinariya klinikasi. Uy hayvonlaringiz salomatligi uchun ishlaymiz.",
  "footer.links": "Tezkor havolalar",
  "footer.contacts": "Kontaktlar",
  "footer.rights": "Barcha huquqlar himoyalangan",

  // Auth
  "auth.title": "ELVET",
  "auth.subtitle": "Boshqaruv tizimiga kirish",
  "auth.login": "Kirish",
  "auth.phoneLogin": "Telefon orqali kirish",
  "auth.registration": "Ro'yxatdan o'tish",
  "auth.loginByMethod": "Tizimga kirish usulini tanlang",
  "auth.phone": "Telefon",
  "auth.phonePlaceholder": "+998 90 123 45 67",
  "auth.phoneHelper": "Format: +998 XX XXX XX XX",
  "auth.invalidPhone": "Telefon formati noto'g'ri",
  "auth.phoneNotFound": "Telefon tizimda topilmadi",
  "auth.password": "Parol",
  "auth.passwordPlaceholder": "••••••••",
  "auth.forgotPassword": "Parolni unutdingizmi?",
  "auth.loginButton": "Kirish",
  "auth.registerViaTelegram": "Telegram orqali ro'yxatdan o'tish",
  "auth.telegramRegisterDesc": "Telegram bot orqali tez va xavfsiz ro'yxatdan o'tish",
  "auth.telegramNote": "Botda ro'yxatdan o'tgandan so'ng, saytda avtomatik tarzda avtorizatsiya qilinasiz",
  "auth.error": "Xato",
  "auth.loginError": "Kirish xatosi",
  "auth.loginSuccess": "Muvaffaqiyatli kirish",
  "auth.welcome": "Xush kelibsiz!",
  "auth.passwordChangeRequired": "Parol o'zgartirish talab qilinadi",
  "auth.setPermPassword": "Iltimos, doimiy parol o'rnating",
  "auth.visitClinic": "Bizning veterinar\nklinikamizga tashrif buyuring",
  "auth.professionalCare": "Sizning uy hayvonlaringiz\nuchun professional g'amxo'rlik",
  "auth.contactTelegram": "Telegram orqali bog'lanish",
  "auth.backToHome": "Bosh sahifaga qaytish",

  // Dashboard
  "dashboard.welcome": "Xush kelibsiz",
  "dashboard.client": "Mijoz shaxsiy kabineti",
  "dashboard.moderator": "Moderator paneli",
  "dashboard.doctor": "Shifokor paneli",
  "dashboard.admin": "Administrator paneli",
  "dashboard.nurse": "Hamshira paneli",
  "dashboard.logout": "Chiqish",
  "dashboard.myPets": "Mening hayvonlarim",
  "dashboard.medicalHistory": "Tibbiy kartalar tarixi",
  "dashboard.medicalHistoryShort": "Tarix",
  "dashboard.medicalCards": "Tibbiy kartalar",
  "dashboard.appointments": "Qabulga yozilishlar",
  "dashboard.profile": "Profil",

  // Doctor page
  "doctor.newCard.title": "Yangi tibbiy karta",
  "doctor.newCard.subtitle": "Uy hayvoni ma'lumotlari, diagnoz, tahlillar, xizmatlar va dori-darmonlarni to'ldiring",
  "doctor.sections.petAndExam": "Uy hayvoni va ko'rik",
  // Tabs (Doctor) - orqaga muvofiqlik uchun
  "doctor.tabs.clients": "Mijozlar",
  "doctor.tabs.services": "Xizmatlar",
  "doctor.tabs.medicines": "Dori-darmonlar",
  "doctor.tabs.history": "Tarix",
  "doctor.tabs.rooms": "Palatalar",
  // Shifokor yon paneli navigatsiyasi
  "doctor.sidebar.navigation": "Navigatsiya",
  "doctor.sidebar.main": "Asosiy",
  "doctor.sidebar.clients": "Mijozlar",
  "doctor.sidebar.services": "Xizmatlar",
  "doctor.sidebar.medicines": "Dori-darmonlar",
  "doctor.sidebar.history": "Tarix",
  "doctor.sidebar.rooms": "Palatalar",
  "doctor.sidebar.salary": "Maosh tarixi",
  "doctor.sidebar.collapse": "Yon panelni yig'ish",
  "doctor.sidebar.expand": "Yon panelni yoyish",
  "doctor.sidebar.hint": "Bo'limlar orasida navigatsiya qilish uchun yon paneldan foydalaning",
  "doctor.pet.selectLabel": "Mijozning hayvoni",
  "doctor.pet.selectPlaceholder": "Hayvonni tanlang",
  "doctor.pet.loading": "Hayvonlar yuklanmoqda…",
  "doctor.pet.loadError": "Hayvonlarni yuklab bo'lmadi",
  "doctor.pet.none": "Hayvonlar yo'q",
  "doctor.pet.create": "Hayvon yaratish",
  "doctor.pet.createHelp": "Mijoz uchun uy hayvoni kartasini yarating",
  "doctor.pet.addNew": "Yangi hayvon qo'shish",
  "doctor.pet.form.title": "Yangi hayvon",
  "doctor.pet.form.subtitle": "Mijoz uchun hayvon yarating",
  "doctor.pet.name": "Ismi",
  "doctor.pet.namePlaceholder": "Barsik",
  "doctor.pet.species": "Turi",
  "doctor.pet.speciesPlaceholder": "Turini tanlang",
  "doctor.pet.species.dog": "It",
  "doctor.pet.species.cat": "Mushuk",
  "doctor.pet.species.bird": "Qush",
  "doctor.pet.species.reptile": "Sudralib yuruvchi",
  "doctor.pet.species.other": "Boshqa",
  "doctor.pet.gender": "Jinsi",
  "doctor.pet.genderPlaceholder": "Jinsni tanlang",
  "doctor.pet.gender.male": "Erkak",
  "doctor.pet.gender.female": "Urg'ochi",
  "doctor.pet.breed": "Zoti",
  "doctor.pet.breedPlaceholder": "Britan",
  "doctor.pet.birthDate": "Tug'ilgan sana",
  "doctor.pet.color": "Rangi",
  "doctor.pet.colorPlaceholder": "Jigar rang",
  "doctor.pet.weight": "Vazn (kg)",
  "doctor.pet.weightPlaceholder": "4.5",
  "doctor.pet.description": "Tavsif",
  "doctor.pet.descriptionPlaceholder": "Surunkali kasalliklar yo'q...",

  "doctor.vitals.weight": "Vazn",
  "doctor.vitals.weightPlaceholder": "4.2",
  "doctor.vitals.temperature": "Harorat",
  "doctor.vitals.temperaturePlaceholder": "38.5",
  "doctor.vitals.bloodPressure": "Qon bosimi (mmHg)",
  "doctor.vitals.bloodPressurePlaceholder": "120",
  "doctor.vitals.heartRate": "Yurak urishi (bpm)",
  "doctor.vitals.heartRatePlaceholder": "90",
  "doctor.vitals.respiratoryRate": "Nafas olish tezligi",
  "doctor.vitals.respiratoryRatePlaceholder": "20",
  "doctor.vitals.mucous": "Shilliq pardalar",
  "doctor.vitals.mucousPlaceholder": "pushti, nam",
  "doctor.vitals.chest": "Ko'krak qafasi holati",
  "doctor.vitals.chestPlaceholder": "h ushqichsiz, perkussiya toza",
  "doctor.vitals.anamnez": "Anamnez (shikoyatlar va belgilar)",
  "doctor.vitals.anamnezPlaceholder": "Joriy shikoyatlar, kasallik tarixi, belgilar...",
  "doctor.vitals.naznacheniya": "Tayinlamalar (Naznacheniya)",
  "doctor.vitals.naznacheniyaPlaceholder": "Davolash rejasi, dorilar, parvarish ko'rsatmalari...",
  "doctor.vitals.statusSection": "Bemor holati (Vital ko'rsatkichlar)",
  "doctor.vitals.generalCondition": "Bemor holati",
  "doctor.vitals.generalConditionPlaceholder": "Vazn: 4.2 kg, Harorat: 38.5°C, Qon bosimi: 120/80, Yurak urishi: 90 bpm, Nafas: 20/min, Shilliq pardalar: pushti nam...",
  "doctor.revisitDate": "Qayta tashrif sanasi",
  "client.medicalCards.naznacheniya": "Tayinlamalar",
  "client.medicalCards.naznacheniya.empty": "—",

  "doctor.services.title": "Xizmatlar",
  "doctor.services.subtitle": "Xizmatlarni tanlang, sonini va tavsifini ko'rsating",
  "doctor.medicines.title": "Dori-darmonlar",
  "doctor.medicines.subtitle": "Dori-darmonlarni tanlang, sonini va dozasini ko'rsating",
  "doctor.feeds.title": "Oziq-ovqatlar",
  "doctor.feeds.subtitle": "Oziq-ovqatlarni tanlang va sonini ko'rsating",
  "doctor.search.servicePlaceholder": "Xizmatni qidirish...",
  "doctor.search.medicinePlaceholder": "Dorini qidirish...",
  "doctor.search.feedPlaceholder": "Oziqni qidirish...",
  "doctor.price": "{{price}} so'm",
  "doctor.inStock": "Mavjud: {{stock}}",
  "doctor.qtyPlaceholder": "Soni",
  "doctor.qtyZeroPlaceholder": "0",
  "doctor.serviceDescPlaceholder": "Bajarilgan xizmat tavsifi",
  "doctor.dosagePlaceholder": "Doza",
  "doctor.clear": "Tozalash",

  "doctor.stationary.title": "Statsionar",
  "doctor.stationary.subtitle": "Zarur bo'lsa statsionarni rasmiylashtiring",
  "doctor.stationary.checkbox": "Statsionar",
  "doctor.stationary.period": "Statsionar davri",
  "doctor.stationary.selectPeriod": "Davrni tanlang",
  "doctor.stationary.noPeriods": "Statsionar davrlari sozlanmagan. Administratorga murojaat qiling.",
  "doctor.stationary.loadError": "Statsionar davrlarini yuklab bo'lmadi",
  "doctor.stationary.room": "Palata",
  "doctor.stationary.selectRoom": "Palatani tanlash",
  "doctor.stationary.roomSelected": "Tanlangan: {{room}}",
  "doctor.stationary.roomIdNote": "Palata ID yuboriladi: {{id}}",
  "doctor.stationary.startDate": "Qabul sanasi",
  "doctor.stationary.endDate": "Chiqish sanasi",

  "doctor.freeRooms.title": "Bo'sh palatalar",
  "doctor.freeRooms.subtitle": "Bemor uchun palatani tanlang",
  "doctor.freeRooms.loading": "Bo'sh palatalar yuklanmoqda…",
  "doctor.freeRooms.id": "ID: {{id}}",
  "doctor.freeRooms.pricePerDay": "Narx/kuni: {{price}}",
  "doctor.freeRooms.select": "Tanlash",
  "doctor.freeRooms.empty": "Bo'sh palatalar topilmadi",

  "doctor.schedule.title": "Statsionar jadvali",
  "doctor.schedule.subtitle": "Davrni belgilang va hamshiraga vazifalar qo'shing",
  "doctor.schedule.datetime": "Sana va vaqt",
  "doctor.schedule.hint": "Bemor qachon qaytishi yoki statsionarni qachon boshlashi kerakligini belgilang.",
  "doctor.schedule.loading": "Jadval ma'lumotlari yuklanmoqda…",
  "doctor.schedule.save": "Jadvalni saqlash",
  "doctor.schedule.cardMissing": "Tibbiy karta tanlanmagan",
  "doctor.schedule.datetimeRequired": "Jadval sanasi va vaqtini kiriting",
  "doctor.schedule.invalidDate": "Sana yoki vaqt noto'g'ri",
  "doctor.schedule.createError": "Jadvalni yaratib bo'lmadi",
  "doctor.schedule.saveSuccess": "Jadval saqlandi",
  "doctor.schedule.saveErrorTitle": "Jadvalni saqlashda xato",
  "doctor.schedule.saveErrorDescription": "Jadvalni saqlashda xatolik yuz berdi",
  "doctor.schedule.nursesLoadError": "Hamshiralar ro'yxatini yuklab bo'lmadi",
  "doctor.schedule.servicesLoadError": "Xizmatlarni yuklab bo'lmadi",

  // Doctor card creation flow
  "doctor.create.validation.selectClient": "Mijozni tanlang",
  "doctor.create.validation.selectPet": "Hayvonni tanlang",
  "doctor.create.validation.selectNurse": "Mas'ul hamshirani tanlang",
  "doctor.create.validation.diagnosis": "Diagnozni kiriting",
  "doctor.create.validation.requiredFieldsTitle": "Majburiy maydonlar to'ldirilmagan",
  "doctor.create.validation.selectItems": "Kamida bitta xizmat, dori yoki oziq qo'shing",
  "doctor.create.validation.medicineDosage": "Har bir tanlangan dorining dozasini kiriting",
  "doctor.create.determineDoctorError": "Shifokor profili topilmadi",
  "doctor.create.tryLater": "Qayta urinib ko'ring yoki administratorga murojaat qiling",
  "doctor.create.createErrorTitle": "Tibbiy kartani yaratib bo'lmadi",
  "doctor.create.serverError": "Server xatosi",
  "doctor.create.idMissingTitle": "Tibbiy karta ID topilmadi",
  "doctor.create.idMissingDescription": "Server karta identifikatorini qaytarmadi",
  "doctor.create.successTitle": "Tibbiy karta yaratildi",
  "doctor.create.successDescription": "Karta №{{id}} muvaffaqiyatli saqlandi",
  "doctor.create.nursesLoadError": "Hamshiralarni yuklab bo'lmadi",
  "doctor.create.assignedNurseLabel": "Mas'ul hamshira",
  "doctor.create.assignedNursePlaceholder": "Hamshirani tanlang",
  "doctor.create.noNurses": "Hamshiralar mavjud emas",
  "doctor.create.pet.noClient": "Hayvon yaratishdan oldin mijozni tanlang",
  "doctor.create.pet.nameRequired": "Hayvon nomini kiriting",
  "doctor.create.pet.speciesRequired": "Hayvon turini tanlang",
  "doctor.create.pet.genderRequired": "Hayvon jinsini tanlang",
  "doctor.create.pet.successTitle": "Hayvon yaratildi",
  "doctor.create.pet.successDescription": "{{name}} mijozga qo'shildi",
  "doctor.create.pet.errorTitle": "Hayvonni yaratib bo'lmadi",
  "doctor.create.pet.errorUnknown": "Hayvonni yaratishda noma'lum xato",

  "doctor.edit.title": "Tibbiy kartani tahrirlash",
  "doctor.edit.subtitle": "To'lovdan oldin tahrirlash mumkin. O'zgarishlar qisman saqlanadi.",
  "doctor.edit.stationarySubtitle": "Administrator sozlagan statsionar davrini tanlang",
  "doctor.edit.stationaryRequiredTitle": "Statsionar davri tanlanmagan",
  "doctor.edit.stationaryRequiredDescription": "Saqlashdan oldin statsionar davrini tanlang.",

  // Doctor salary history
  "doctor.salary.today": "Bugungi daromad",
  "doctor.salary.weekly": "Haftalik daromad",
  "doctor.salary.monthly": "Oylik daromad",
  "doctor.salary.dropdown.weekly": "Hafta",
  "doctor.salary.dropdown.monthly": "Oy",
  "doctor.salary.total": "Jami",
  "doctor.salary.events": "Voqealar",
  "doctor.salary.empty": "Daromad voqealari yo'q",
  "doctor.salary.loading": "Daromad tarixi yuklanmoqda…",
  "doctor.salary.error": "Yuklash xatosi",
  "doctor.salary.errorDesc": "Daromad tarixini olish muvaffaqiyatsiz tugadi",
  "doctor.salary.source.SERVICE_USAGE": "Xizmatdan foydalanish",
  "doctor.salary.source.OTHER": "Boshqa",
  
  // Doctor schedule task builder
  "doctor.schedule.addTaskTitle": "Vazifa qo'shish",
  "doctor.schedule.addTaskSubtitle": "Kim, qachon va nima qiladi",
  "doctor.schedule.task.validationTitle": "Vazifa ma'lumotlarini tekshiring",
  "doctor.schedule.task.validationDescription": "Nom, tavsif, muddatlar, hamshira va xizmatni to'ldiring",
  "doctor.schedule.task.validationExtended": "Vazifa nomi, tavsifi, boshlanish/tugash vaqti, hamshira va xizmat talab qilinadi",
  "doctor.schedule.task.nameLabel": "Vazifa nomi",
  "doctor.schedule.task.namePlaceholder": "Inyeksiya, ovqatlantirish...",
  "doctor.schedule.task.startDateLabel": "Boshlanish sanasi",
  "doctor.schedule.task.startTimeLabel": "Boshlanish vaqti",
  "doctor.schedule.task.deadlineDateLabel": "Tugash sanasi",
  "doctor.schedule.task.deadlineTimeLabel": "Tugash vaqti",
  "doctor.schedule.task.nurseLabel": "Hamshira",
  "doctor.schedule.task.nurseSelectPlaceholder": "Hamshirani tanlang",
  "doctor.schedule.task.nurseSelectLoading": "Yuklanmoqda…",
  "doctor.schedule.task.noUsers": "Mavjud foydalanuvchilar yo'q",
  "doctor.schedule.task.serviceLabel": "Xizmat",
  "doctor.schedule.task.serviceSelectPlaceholder": "Xizmatni tanlang",
  "doctor.schedule.task.serviceSelectLoading": "Yuklanmoqda…",
  "doctor.schedule.task.noServices": "Xizmatlar yo'q",
  "doctor.schedule.task.descriptionLabel": "Tavsif",
  "doctor.schedule.task.descriptionPlaceholder": "Antibiotik inyeksiyasi, parvarish...",
  "doctor.schedule.task.addButton": "Qo'shish",
  "doctor.schedule.task.createError": "Vazifani yaratib bo'lmadi",
  "doctor.schedule.tasksTitle": "Vazifalar",
  "doctor.schedule.tasksSubtitle": "Davr rejasi",
  "doctor.schedule.tasksEmpty": "Vazifalar yo'q",
  "doctor.schedule.task.untitled": "Nomsiz",
  "doctor.schedule.task.persistedBadge": "saqlandi",
  "doctor.schedule.task.startPrefix": "Start:",
  "doctor.schedule.task.deadlinePrefix": "Muddat:",
  "doctor.schedule.task.deleteButton": "O'chirish",

  // Generic fetch helper
  "doctor.fetch.errorTitle": "Ma'lumotni yuklab bo'lmadi",
  "doctor.fetch.errorDescription": "{{resource}} ni yuklab bo'lmadi",

  // Common additions
  "common.cancel": "Bekor qilish",
  "common.save": "Saqlash",
  "common.create": "Yaratish",
  "common.creating": "Yaratilmoqda…",
  "common.saving": "Saqlanmoqda…",
  "common.loading": "Yuklanmoqda…",
  "common.empty": "Ma'lumot yo'q",
  "common.view": "Ko'rish",
  "common.close": "Yopish",
  "common.confirmPayment": "To'lovni tasdiqlash",
  "common.confirmed": "Tasdiqlandi",
  "common.error": "Xato",
  "common.nothingFound": "Hech narsa topilmadi",
  
  // Tabs (Nurse)
  "nurse.tabs.procedures": "Protseduralar",
  "nurse.tabs.medicines": "Dori-darmonlar",
  "nurse.tabs.schedule": "Jadval",

  // Tabs (Moderator)
  "moderator.tabs.billing": "Tibbiy kartalar",
  "moderator.tabs.visits": "Tashriflar",
  "moderator.tabs.password": "Mijoz paroli",
  "moderator.tabs.requests": "So'rovlar",
  
  // Moderator dashboard KPI
  "moderator.kpi.medicinesAvailable": "Mavjud dori-darmonlar",
  "moderator.kpi.servicesCount": "Xizmatlar jami",
  "moderator.kpi.visitsCount": "Tashriflar jami",

  // Moderator medical cards section
  "moderator.medicalCards.title": "Tibbiy kartalar",
  "moderator.medicalCards.subtitle": "To'lovni kutayotgan kartalar",
  "moderator.medicalCards.refresh": "Ro'yxatni yangilash",

  // Moderator visits section
  "moderator.visits.create.title": "Tashrif yaratish",
  "moderator.visits.create.subtitle": "Mijoz, shifokor va hayvonni tanlang",
  "moderator.visits.history.title": "Tashriflar tarixi",
  "moderator.visits.history.subtitle": "Tashriflar ro'yxati",
  "moderator.visits.refresh": "Yangilash",

  // Moderator requests section
  "moderator.requests.title": "Mijoz so'rovlari",
  "moderator.requests.subtitle": "Saytdan yuborilgan murojaatlar",
  "moderator.requests.refresh": "Yangilash",

  // Moderator card modal
  "moderator.card.modal.title": "Karta #{{id}}",
  "moderator.card.modal.subtitle": "Kartani ko'rish va to'lovni tasdiqlash",
  "moderator.card.modal.client": "Mijoz",
  "moderator.card.modal.pet": "Hayvon",
  "moderator.card.modal.status": "Holat",
  "moderator.card.modal.total": "Jami",
  
  // Doctor clients tab & client profile
  "doctor.clients.title": "Mijozlar",
  "doctor.clients.subtitle": "Mijozlar ro'yxati va telefonlar",
  "doctor.profile.notFoundTitle": "Shifokor profili topilmadi",
  "doctor.profile.notFoundDescription": "Administratorga murojaat qiling",
  "doctor.clients.searchPlaceholder": "Ism yoki telefon bo'yicha qidirish...",
  "doctor.clients.loading": "Mijozlar yuklanmoqda…",
  "doctor.clients.profileButton": "Profil",
  "doctor.clients.nothing": "Hech narsa topilmadi",
  "doctor.clients.total": "Jami: {{count}}",
  "doctor.clientProfile.title": "Mijoz profili",
  "doctor.clientProfile.subtitle": "Mijoz kartasi va tibbiy kartalar",
  "doctor.clientProfile.phone": "Telefon:",
  "doctor.clientProfile.address": "Manzil:",
  "doctor.clientProfile.description": "Tavsif:",
  "doctor.clientProfile.close": "Yopish",
  "doctor.clientProfile.createCard": "Tibbiy karta yaratish",
  "doctor.clientCards.title": "Mijoz tibbiy kartalari",
  "doctor.clientCards.subtitle": "Oxirgi yozuvlar",
  "doctor.clientCards.loadError": "Tibbiy kartalarni yuklab bo'lmadi",
  "doctor.clientCards.status.open": "Ochiq",
  "doctor.clientCards.status.waiting": "To'lov kutilmoqda",
  "doctor.clientCards.status.closed": "Yopiq",
  "doctor.clientCards.edit": "Tahrirlash",
  "doctor.clientCards.empty": "Kartalar yo'q",

  // Doctor services list tab
  "doctor.servicesList.title": "Mavjud xizmatlar",
  "doctor.servicesList.subtitle": "Xizmatlar katalogi",
  "doctor.servicesList.searchPlaceholder": "Xizmat qidirish...",
  "doctor.servicesList.loading": "Xizmatlar yuklanmoqda…",
  "doctor.servicesList.empty": "Hech narsa topilmadi",
  "doctor.servicesList.total": "Jami: {{count}}",

  // Doctor medicines list tab
  "doctor.medicinesList.title": "Mavjud dori-darmonlar",
  "doctor.medicinesList.subtitle": "Ombor qoldiqlari",
  "doctor.medicinesList.searchPlaceholder": "Dori qidirish...",
  "doctor.medicinesList.loading": "Dori-darmonlar yuklanmoqda…",
  "doctor.medicinesList.empty": "Hech narsa topilmadi",
  "doctor.medicinesList.stockPrefix": "Qoldiq: {{stock}}",
  "doctor.medicinesList.unitDefault": "dona",
  "doctor.medicinesList.total": "Jami: {{count}}",

  // Doctor history tab
  "doctor.history.title": "Kartalar tarixi (meniki)",
  "doctor.history.subtitle": "Yaqinda yaratilgan/ochilgan kartalar",
  "doctor.history.loading": "Tarix yuklanmoqda…",
  "doctor.history.status.open": "Ochiq",
  "doctor.history.status.waiting": "To'lov kutilmoqda",
  "doctor.history.status.closed": "Yopiq",
  "doctor.history.edit": "Tahrirlash",
  "doctor.history.viewDisabled": "Ko'rish mumkin emas",
  "doctor.history.empty": "Ma'lumot yo'q",
  "doctor.history.total": "Jami: {{count}}",

  // Doctor rooms tab
  "doctor.rooms.title": "Palatalar",
  "doctor.rooms.subtitle": "Mavjud statsionar palatalar",
  "doctor.rooms.loading": "Palatalar yuklanmoqda…",
  "doctor.rooms.roomLabel": "Palata",
  "doctor.rooms.free": "Bo'sh",
  "doctor.rooms.busy": "Band",
  "doctor.rooms.pricePerDayPrefix": "Narx/kuni:",
  "doctor.rooms.noDescription": "Tavsif yo'q",
  "doctor.rooms.empty": "Ma'lumot yo'q",
  "doctor.rooms.total": "Jami: {{count}}",

  // Fallback labels
  "doctor.pet.fallback": "Hayvon #{{id}}",
  "doctor.room.fallback": "Palata #{{id}}",

  // Pagination/common nav
  "common.prev": "Oldingi",
  "common.next": "Keyingi",
  "doctor.currency.som": "so'm",
  
  // Doctor hero & banner
  "doctor.hero.subtitle": "Shifokor boshqaruv paneli",
  "doctor.hero.fallbackRole": "Shifokor",
  "doctor.banner.edit": "O'zgartirish",
  "doctor.banner.loading": "Yuklanmoqda…",
  
  // Doctor stats boxes
  "doctor.stats.services.title": "Xizmatlar",
  "doctor.stats.services.subtitle": "Mavjud (turlari)",
  "doctor.stats.medicines.title": "Dori-darmonlar",
  "doctor.stats.medicines.subtitle": "Omborda (turlari)",
  "doctor.stats.feeds.title": "Ozuqalar",
  "doctor.stats.feeds.subtitle": "Mavjud (turlari)",
  
  // Common navigation
  "common.goHome": "Bosh sahifaga",
  "common.delete": "O'chirish",
  "common.search": "Qidirish",

  // Edit card modal - services
  "doctor.edit.services.title": "Hisob-fakturadagi xizmatlar",
  "doctor.edit.services.subtitle": "Miqdor, tavsifni o'zgartiring yoki yangi xizmat qo'shing",
  "doctor.edit.services.fallback": "Xizmat #{{id}}",
  "doctor.edit.services.descriptionPlaceholder": "Tavsif",
  "doctor.edit.services.delete": "O'chirish",
  "doctor.edit.services.empty": "Xizmatlar yo'q",
  "doctor.edit.services.add": "Xizmat qo'shish",
  "doctor.edit.services.search": "Qidirish",

  // Edit card modal - medicines
  "doctor.edit.medicines.title": "Hisob-fakturadagi dori-darmonlar",
  "doctor.edit.medicines.subtitle": "Miqdor/dozani o'zgartiring yoki yangi dori qo'shing",
  "doctor.edit.medicines.fallback": "Dori #{{id}}",
  "doctor.edit.medicines.dosagePlaceholder": "Doza",
  "doctor.edit.medicines.delete": "O'chirish",
  "doctor.edit.medicines.empty": "Dori-darmonlar yo'q",
  "doctor.edit.medicines.add": "Dori qo'shish",
  "doctor.edit.medicines.search": "Qidirish",

  // Edit card modal - feeds
  "doctor.edit.feeds.title": "Hisob-fakturadagi ozuqalar",
  "doctor.edit.feeds.subtitle": "Miqdorini o'zgartiring yoki yangi ozuqa qo'shing",
  "doctor.edit.feeds.fallback": "Ozuqa #{{id}}",
  "doctor.edit.feeds.selectPlaceholder": "Ozuqani tanlang",
  "doctor.edit.feeds.delete": "O'chirish",
  "doctor.edit.feeds.empty": "Ozuqalar yo'q",
  "doctor.edit.feeds.add": "Ozuqa qo'shish",
  "doctor.edit.feeds.search": "Qidirish",
  
  // Client dashboard - Appointments
  "client.appointments.title": "Mening uchrashuvlarim",
  "client.appointments.create": "Qabulga yozilish",
  "client.appointments.status.waiting": "Kutilmoqda",
  "client.appointments.status.confirmed": "Tasdiqlangan",
  "client.appointments.status.canceled": "Bekor qilingan",
  "client.appointments.cancel.confirmTitle": "Uchrashuv bekor qilinsinmi?",
  "client.appointments.cancel.confirmDescription": "Bu uchrashuvni bekor qilmoqchiligingizga ishonchingiz komilmi?",
  "client.appointments.toast.createSuccess": "Uchrashuv yaratildi",
  "client.appointments.toast.createError": "Uchrashuvni yaratib bo‘lmadi",
  "client.appointments.toast.cancelSuccess": "Uchrashuv bekor qilindi",
  "client.appointments.toast.cancelError": "Uchrashuvni bekor qilib bo‘lmadi",
  "client.appointments.dialogTitle": "Qabulga yozilish",
  "client.appointments.dialogDescription": "Sana, vaqt va shifokorni tanlang",
  "client.appointments.pet.label": "Hayvon",
  "client.appointments.pet.placeholder": "Hayvonni tanlang",
  "client.appointments.doctor.label": "Shifokor",
  "client.appointments.doctor.placeholder": "Shifokorni tanlang",
  "client.appointments.date.label": "Sana *",
  "client.appointments.time.label": "Vaqt *",
  "client.appointments.service.label": "Xizmat turi",
  "client.appointments.service.placeholder": "Konsultatsiya, emlash...",
  "client.appointments.notes.label": "Izohlar",
  "client.appointments.notes.placeholder": "Muammoni tasvirlang...",
  "client.appointments.submit": "Yozilish",
  "client.appointments.submitting": "Yozilmoqda...",
  "client.appointments.manageDescription": "Uchrashuvlarni boshqarish",
  "client.appointments.empty": "Sizda yaqinlashib kelayotgan uchrashuvlar yo‘q",
  "client.appointments.petPrefix": "Hayvon:",
  "client.appointments.doctorPrefix": "Shifokor:",
  "client.appointments.status.completed": "Tugallangan",
  "client.appointments.status.cancelled": "Bekor qilingan",

  // Client dashboard - Password dialog
  "client.password.dialogTitle": "Doimiy parolni o‘rnatish",
  "client.password.passwordMismatch": "Parollar mos kelmaydi",
  "client.password.passwordTooShort": "Parol kamida 6 belgidan iborat bo‘lishi kerak",
  "client.password.saveSuccess": "Parol saqlandi",
  "client.password.saveError": "Parolni saqlab bo‘lmadi",

  // Client dashboard - Medical cards viewer
  "client.medicalCards.title": "Tibbiy kartalar",
  "client.medicalCards.historyTitle": "Tashriflar tarixi",
  "client.medicalCards.status.pending": "Kutilmoqda",
  "client.medicalCards.status.paid": "To'langan",
  "client.medicalCards.status.partlyPaid": "Qisman to'langan",
  "client.medicalCards.stationaryBadge": "Statsionar",
  "client.medicalCards.services": "Xizmatlar",
  "client.medicalCards.medicines": "Dorilar",
  "client.medicalCards.services.empty": "Xizmatlar yo'q",
  "client.medicalCards.medicines.empty": "Dorilar yo'q",
  "client.medicalCards.stationaryRoom.title": "Statsionar palata",
  "client.medicalCards.stationaryRoom.payment": "Statsionar to'lovi",

  // Client dashboard - Pets manager
  "client.pets.title": "Mening hayvonlarim",
  "client.pets.addPet": "Hayvon qo‘shish",
  "client.pets.updatePet": "Hayvonni yangilash",
  "client.pets.empty": "Ro‘yxatdan o‘tgan hayvonlar yo‘q",
  "client.pets.namePlaceholder": "Barsik",
  "client.pets.breedPlaceholder": "Labrador",
  "client.pets.toast.createSuccess": "Hayvon qo‘shildi",
  "client.pets.toast.updateSuccess": "Hayvon yangilandi",
  "client.pets.toast.deleteSuccess": "Hayvon o‘chirildi",
  "client.pets.toast.errorGeneric": "Amal bajarilmadi",

  // Client dashboard - Profile editor
  "client.profile.title": "Mening profilim",
  "client.profile.subtitle": "Shaxsiy ma’lumotlar",
  "client.profile.firstName": "Ism",
  "client.profile.lastName": "Familiya",
  "client.profile.photo": "Profil surati",
  "client.profile.address": "Manzil",
  "client.profile.phonePrimary": "Asosiy telefon",
  "client.profile.phoneSecondary": "Qo‘shimcha telefon",
  "client.profile.phoneInvalid": "Telefon formati noto‘g‘ri",
  "client.profile.phonesMustDiffer": "Telefon raqamlari har xil bo'lishi kerak",
  "client.profile.error.duplicatePhone": "Takroriy telefon raqami",
  "client.profile.error.phoneAlreadyInUse": "Bu telefon raqami ({{phone}}) boshqa hisob tomonidan ishlatilmoqda",
  "client.profile.edit": "Profilni tahrirlash",
  "client.profile.toast.updateSuccess": "Profil yangilandi",
  "client.profile.toast.photoUpdateSuccess": "Foto yangilandi",
  "client.profile.toast.updateError": "Profilni yangilab bo‘lmadi",
  "client.profile.subtitleExtended": "Shaxsiy maʼlumotlar va akkaunt sozlamalari",
  "client.profile.extraPhone1": "Qo‘shimcha raqam 1",
  "client.profile.extraPhone2": "Qo‘shimcha raqam 2",
  "client.profile.photo.change": "Almashtirish",
  "client.profile.photo.uploading": "Yuklanmoqda...",
  "client.profile.saving": "Saqlanmoqda...",
  "client.profile.phone.helper": "Format: +998 XX XXX XX XX",
  
  // Client pets manager extended
  "client.pets.dialog.description": "Uy hayvoningiz haqida ma'lumotlarni kiriting",
  "client.pets.addNew": "Yangi hayvon qo‘shish",
  "client.pets.update": "Hayvonni yangilash",
  "client.pets.name.label": "Ism *",
  "client.pets.species.label": "Hayvon turi *",
  "client.pets.gender.label": "Jinsi *",
  "client.pets.breed.label": "Zoti",
  "client.pets.birthDate.label": "Tug‘ilgan sana",
  "client.pets.color.label": "Rangi",
  "client.pets.weight.label": "Vazn (kg)",
  "client.pets.notes.label": "Izohlar",
  "client.pets.photo.label": "Hayvon fotosi",
  "client.pets.invalidBirthDateTitle": "Noto‘g‘ri tug‘ilgan sana",
  "client.pets.invalidBirthDateDescription": "Tug‘ilgan sana kelajak bo‘lishi mumkin emas",
  "client.pets.toast.createDescription": "{{name}} muvaffaqiyatli ro‘yxatdan o‘tkazildi",
  "client.pets.toast.deleteDescription": "{{name}} ro‘yxatdan olib tashlandi",
  "client.pets.deleteConfirm": "{{name}} hayvonini o‘chirilsinmi?",
  "client.pets.age.label": "Yoshi",
  "client.pets.age.yearsSuffix": "yil",
  "client.pets.notes.heading": "Izohlar:",
  "client.pets.emptyHelp": "Salomatlikni kuzatishni boshlash uchun birinchi hayvoningizni qo‘shing",
  "client.pets.creating": "Yaratilmoqda...",
  "client.pets.saving": "Saqlanmoqda...",
  "client.pets.reptile": "Sudraluvchi",
  
  // Client medical cards extended
  "client.medicalCards.subtitle": "Uy hayvonlaringiz tashriflari va davolanish tarixi",
  "client.medicalCards.empty": "Tibbiy kartalar topilmadi",
  "client.medicalCards.column.pending": "Kutilmoqda",
  "client.medicalCards.column.paid": "To‘langan",
  "client.medicalCards.petFallback": "Hayvon",
  "client.medicalCards.detailsToggle": "Tafsilotlar (xizmatlar va tavsiyalar)",
  "client.medicalCards.doctor.loading": "Doktor: yuklanmoqda...",
  "client.medicalCards.doctor.unknown": "Doktor: noma'lum",
  "client.medicalCards.doctor.prefix": "Dr.",
  "client.medicalCards.assignedNurse": "Mas'ul hamshira",
  "client.medicalCards.assignedNurse.unknown": "Tayinlanmagan",
  
  // Nurse medical card view
  "nurse.medicalCards.assignedNurse": "Mas'ul hamshira",
  
  // Client dashboard banner/nav helpers
  "client.hero.fallbackRole": "Mijoz",
  "client.dashboard.welcomeSubtitle": "Uy hayvonlaringiz salomatligini bir joyda boshqaring",
  "client.logout.goodbye": "Xayr!",
  "client.revisit.reminder": "Ertaga ELVET'ga tashrif buyurishingiz kerak — shifokor {{petName}} uchun qayta ko'rikni {{date}} sanasiga belgiladi.",
  "client.revisit.dismiss": "Yopish",

  // Common extra
  "common.goodbye": "Xayr!",

  // Nurse banner & profile
  "nurse.banner.subtitle": "Bemorlar parvarishi",
  "nurse.banner.dailySalaryLabel": "Joriy kunlik stavka:",
  "nurse.banner.defaultName": "Hamshira",
  "nurse.banner.changeImage": "O'zgartirish",
  "nurse.banner.uploading": "Yuklanmoqda...",
  "nurse.profileNotFound.title": "Hamshira profili topilmadi",
  "nurse.profileNotFound.description": "Administrator bilan bog'laning",
  "nurse.profileNotFound.inlineWarning": "Hamshira profilingiz aniqlanmadi. Vazifalar bilan ishlashni davom ettirish uchun administratorga murojaat qiling.",

  // Nurse sidebar navigation
  "nurse.sidebar.navigation": "Navigatsiya",
  "nurse.sidebar.main": "Asosiy",
  "nurse.sidebar.procedures": "Protseduralar",
  "nurse.sidebar.medicalCards": "Tibbiy kartalar",
  "nurse.sidebar.nurseCare": "Hamshira parvarishi",
  "nurse.sidebar.medicines": "Dori-darmonlar",
  "nurse.sidebar.schedule": "Jadval",
  "nurse.sidebar.salary": "Maosh tarixi",
  "nurse.sidebar.collapse": "Yon panelni yig'ish",
  "nurse.sidebar.expand": "Yon panelni ochish",
  "nurse.sidebar.hint": "Bo'limlar o'rtasida navigatsiya qilish uchun yon paneldan foydalaning",

  // Nurse metrics boxes
  "nurse.metrics.title": "Ish ko'rsatkichlari",
  "nurse.metrics.refresh": "Yangilash",
  "nurse.metrics.salary.label": "Kunlik stavka",
  "nurse.metrics.salary.subtitle": "Vazifalar bajarilgandan so'ng yangilanadi",
  "nurse.metrics.todo.label": "Jarayondagi vazifalar",
  "nurse.metrics.todo.subtitle": "Bajarilishini kutmoqda",
  "nurse.metrics.doneToday.label": "Bugun bajarilgan",
  "nurse.metrics.doneToday.subtitle": "Bugun yakunlangan",
  "nurse.metrics.done.label": "Jami bajarilgan",
  "nurse.metrics.done.subtitle": "Bajarilgan vazifalar tarixi",
  "nurse.metrics.medicines.label": "Ombordagi dori-darmonlar",
  "nurse.metrics.medicines.subtitle": "Mavjud pozitsiyalar",
  "nurse.metrics.pets.label": "Klinikadagi hayvonlar",
  "nurse.metrics.pets.subtitle": "Jami ro'yxatdan o'tgan",
  "nurse.metrics.roomsTaken.label": "Band o'rinlar",
  "nurse.metrics.roomsTaken.subtitle": "Palatalarda band o'rinlar",

  // Nurse medicines tab
  "nurse.medicines.title": "Dori-darmon ombori",
  "nurse.medicines.description": "Ma'lumotlar bazasidagi barcha dori-darmonlar joriy qoldiqlari bilan",
  "nurse.medicines.loading": "Ombor ma'lumotlari yangilanmoqda...",
  "nurse.medicines.empty": "Dori-darmonlar ro'yxati bo'sh",
  "nurse.medicines.total": "Jami: {{count}}",
  "nurse.medicines.searchPlaceholder": "Dori-darmonlarni nomi yoki kategoriyasi bo'yicha qidirish...",
  "nurse.medicines.noSearchResults": "Qidiruv bo'yicha dori-darmonlar topilmadi",
  "nurse.medicines.clearSearch": "Qidiruvni tozalash",
  "nurse.medicines.searchResults": "{{total}} ta dori-darmondan {{count}} tasi ko'rsatilmoqda",
  "nurse.medicines.table.name": "Nomi",
  "nurse.medicines.table.category": "Kategoriya",
  "nurse.medicines.table.stock": "Qoldiq",
  "nurse.medicines.table.updated": "Yangilangan",

  // Nurse schedule tab
  "nurse.schedule.title": "Protseduralar jadvali",
  "nurse.schedule.empty": "Sana belgilangan vazifalar topilmadi",
  "nurse.schedule.tasks_one": "{{count}} vazifa",
  "nurse.schedule.tasks_other": "{{count}} vazifalar",
  "nurse.task.untitled": "Nomsiz",

  // Nurse tasks component
  "nurse.tasks.title": "Bemor parvarishi vazifalari",
  "nurse.tasks.description": "Hamshira uchun protseduralar ish ro'yxati",
  "nurse.tasks.refresh": "Yangilash",
  "nurse.tasks.loading": "Vazifalar yuklanmoqda...",
  "nurse.tasks.profileMissing": "Hamshira profili topilmadi. Administratorga murojaat qiling.",
  "nurse.tasks.tab.todo": "Jarayonda",
  "nurse.tasks.tab.today": "Bugun",
  "nurse.tasks.tab.done": "Bajarilgan",
  "nurse.tasks.empty": "Ro'yxat bo'sh",
  "nurse.tasks.table.task": "Vazifa",
  "nurse.tasks.table.patient": "Bemor",
  "nurse.tasks.table.service": "Xizmat",
  "nurse.tasks.table.scheduled": "Rejalashtirilgan",
  "nurse.tasks.table.deadline": "Muddat",
  "nurse.tasks.table.details": "Tafsilotlar",
  "nurse.tasks.badge.notToday": "Bugun emas",
  "nurse.tasks.untitled": "Nomsiz",
  "nurse.tasks.dialog.titleFallback": "Vazifa",
  "nurse.tasks.dialog.description": "Bajarilgan deb belgilashdan oldin tafsilotlarni ko'ring.",
  "nurse.tasks.dialog.detailsNotFound": "Vazifa tafsilotlari topilmadi",
  "nurse.tasks.dialog.updatingDetails": "Bemor va xizmat ma'lumotlari yangilanmoqda...",
  "nurse.tasks.dialog.patient": "Bemor",
  "nurse.tasks.dialog.service": "Xizmat",
  "nurse.tasks.dialog.scheduled": "Rejalashtirilgan",
  "nurse.tasks.dialog.deadline": "Muddat",
  "nurse.tasks.dialog.descriptionLabel": "Tavsif",
  "nurse.tasks.dialog.cardNumber": "Karta #{{number}}",
  "nurse.tasks.dialog.close": "Yopish",
  "nurse.tasks.dialog.alreadyDone": "Vazifa allaqachon bajarilgan sifatida belgilangan.",
  "nurse.tasks.dialog.onlyFromTodo": "Faqat jarayondagi vazifalar ichki yorlig'idan bajarilgan deb belgilanishi mumkin.",
  "nurse.tasks.dialog.onlyToday": "Faqat bugunga rejalashtirilgan vazifalar bajarilgan deb belgilanishi mumkin.",
  "nurse.tasks.dialog.completeButton.completed": "Allaqachon bajarilgan",
  "nurse.tasks.dialog.completeButton.markDone": "Bajarildi deb belgilash",
  "nurse.tasks.dialog.alreadyCompletedToast": "Vazifa allaqachon bajarilgan",
  "nurse.tasks.dialog.cannotCompleteEarlyTitle": "Vazifani erta bajarib bo'lmaydi",
  "nurse.tasks.dialog.cannotCompleteEarlyDescription": "Faqat bugun rejalashtirilgan vazifalar bajarilgan deb belgilanishi mumkin.",
  "nurse.tasks.toast.done": "Vazifa bajarildi",
  "nurse.tasks.toast.updateError": "Vazifani yangilab bo'lmadi",
  "nurse.tasks.fallback.service": "Xizmat #{{id}}",
  "nurse.tasks.fallback.medicine": "Dori #{{id}}",
  "nurse.tasks.fallback.pet": "Hayvon #{{id}}",

  // Nurse Salary tab
  "nurse.tabs.salaryHistory": "Ish haqi tarixi",
  "nurse.salary.weeklyTitle": "Haftalik ish haqi tarixi",
  "nurse.salary.monthlyTitle": "Oylik ish haqi tarixi",
  "nurse.salary.loading": "Ish haqi tarixi yuklanmoqda...",
  "nurse.salary.empty": "Ish haqi bo'yicha hodisalar yo'q",
  "nurse.salary.table.date": "Sana",
  "nurse.salary.table.amount": "Miqdor",

  // Moderator dashboard - additional strings
  "moderator.banner.subtitle": "Klinika moderator paneli",
  "moderator.banner.fallbackRole": "Moderator",
  "moderator.banner.changeImage": "O'zgartirish",
  "moderator.banner.uploading": "Yuklanmoqda…",
  "moderator.tabs.clients": "Mijozlar",
  "moderator.tabs.addUser": "Foydalanuvchi qo'shish",
  "moderator.tabs.nurseCare": "Nurse Care",
  "moderator.tabs.feedSales": "Oziq-ovqat sotuvi",
  "moderator.tabs.feedInventory": "Oziq-ovqat ombori",
  "moderator.clients.title": "Mijozlar",
  "moderator.clients.subtitle": "Klinikaning barcha mijozlari ro'yxati",
  "moderator.clients.filter.id": "Mijoz ID",
  "moderator.clients.filter.idPlaceholder": "Masalan: 123",
  "moderator.clients.filter.name": "Ism yoki familiya",
  "moderator.clients.filter.namePlaceholder": "Mijoz ismi yoki familiyasi",
  "moderator.clients.filter.phone": "Telefon",
  "moderator.clients.filter.phonePlaceholder": "Telefon bo'yicha qidirish",
  "moderator.clients.table.id": "ID",
  "moderator.clients.table.firstName": "Ism",
  "moderator.clients.table.lastName": "Familiya",
  "moderator.clients.table.phone": "Telefon",
  "moderator.clients.table.extraPhone1": "Qo'shimcha telefon 1",
  "moderator.clients.table.extraPhone2": "Qo'shimcha telefon 2",
  "moderator.clients.empty": "Ko'rsatish uchun mijozlar yo'q",
  "moderator.addUser.title": "Yangi mijozni ro'yxatdan o'tkazish",
  "moderator.addUser.subtitle": "Telefon va parolni ko'rsatib mijoz yarating. Ism va familiya ixtiyoriy.",
  "moderator.addUser.phone": "Telefon",
  "moderator.addUser.phonePlaceholder": "+998901234567",
  "moderator.addUser.password": "Parol",
  "moderator.addUser.passwordPlaceholder": "Minimal 6 belgi",
  "moderator.addUser.passwordShow": "Parolni ko'rsatish",
  "moderator.addUser.passwordHide": "Parolni yashirish",
  "moderator.addUser.firstName": "Ism (ixtiyoriy)",
  "moderator.addUser.lastName": "Familiya (ixtiyoriy)",
  "moderator.addUser.submit": "Mijoz yaratish",
  "moderator.addUser.phoneInvalid": "Telefon formati noto'g'ri",
  "moderator.addUser.phoneUsed": "Bu raqam allaqachon ishlatilmoqda",
  "moderator.addUser.checkingPhone": "Raqam tekshirilmoqda…",
  "moderator.addUser.validation.required": "Maydonlarni tekshiring",
  "moderator.addUser.validation.requiredDesc": "Telefon va parol majburiy",
  "moderator.addUser.validation.phoneInvalid": "Telefon noto'g'ri",
  "moderator.addUser.validation.phoneInvalidDesc": "Telefon raqamini tekshiring",
  "moderator.addUser.success": "Mijoz yaratildi",
  "moderator.addUser.error": "Xato",
  "moderator.addUser.errorDesc": "Mijozni yaratib bo'lmadi",
  "moderator.visits.create.client": "Mijoz",
  "moderator.visits.create.clientPlaceholder": "Mijozni tanlang",
  "moderator.visits.create.doctor": "Shifokor",
  "moderator.visits.create.doctorPlaceholder": "Shifokorni tanlang",
  "moderator.visits.create.pet": "Hayvon",
  "moderator.visits.create.petPlaceholder": "Hayvonni tanlang",
  "moderator.visits.create.validation": "Maydonlarni tekshiring",
  "moderator.visits.create.validationDesc": "Mijoz va shifokorni tanlang",
  "moderator.visits.create.success": "Tashrif yaratildi",
  "moderator.visits.create.error": "Xato",
  "moderator.visits.create.errorDesc": "Tashrifni yaratib bo'lmadi",
  "moderator.visits.table.date": "Sana",
  "moderator.visits.table.client": "Mijoz",
  "moderator.visits.table.doctor": "Shifokor",
  "moderator.visits.table.pet": "Hayvon",
  "moderator.requests.table.id": "ID",
  "moderator.requests.table.firstName": "Ism",
  "moderator.requests.table.lastName": "Familiya",
  "moderator.requests.table.phone": "Telefon",
  "moderator.requests.table.created": "Yaratilgan",
  "moderator.card.table.id": "ID",
  "moderator.card.table.client": "Mijoz",
  "moderator.card.table.pet": "Hayvon",
  "moderator.card.table.amount": "Miqdor",
  "moderator.card.table.status": "Holat",
  "moderator.card.table.actions": "Harakatlar",
  "moderator.card.partlyPaid.title": "Qisman to'langan kartalar",
  "moderator.card.partlyPaid.status": "Holat: PARTLY_PAID",
  "moderator.card.partlyPaid.table.total": "Jami",
  "moderator.card.partlyPaid.table.paid": "To'langan",
  "moderator.card.partlyPaid.table.outstanding": "Qoldiq",
  "moderator.card.modal.paid": "To'langan",
  "moderator.card.modal.outstanding": "To'lanishi kerak bo'lgan qoldiq",
  "moderator.card.modal.progress": "To'lov progressi",
  "moderator.card.modal.anamnesis": "Anamnez",
  "moderator.card.modal.recommendedFeed": "Shifokor tavsiya qilgan oziq-ovqat",
  "moderator.card.modal.feeTotal": "Jami (total_fee)",
  "moderator.card.modal.feeStationary": "Statsionar (stationary_fee)",
  "moderator.card.modal.feeMedicines": "Dori-darmonlar (medicines_fee)",
  "moderator.card.modal.feeServices": "Xizmatlar (services_fee)",
  "moderator.card.modal.servicesTitle": "Ishlatilgan xizmatlar",
  "moderator.card.modal.servicesTable.service": "Xizmat",
  "moderator.card.modal.servicesTable.quantity": "Soni",
  "moderator.card.modal.servicesTable.price": "Narx",
  "moderator.card.modal.servicesTable.total": "Jami",
  "moderator.card.modal.medicinesTitle": "Ishlatilgan dori-darmonlar",
  "moderator.card.modal.medicinesTable.medicine": "Dori",
  "moderator.card.modal.medicinesTable.quantity": "Soni",
  "moderator.card.modal.medicinesTable.price": "Narx",
  "moderator.card.modal.medicinesTable.total": "Jami",
  "moderator.card.modal.paymentsTitle": "To'lovlar",
  "moderator.card.modal.paymentsTable.date": "Sana",
  "moderator.card.modal.paymentsTable.method": "Usul",
  "moderator.card.modal.paymentsTable.amount": "Miqdor",
  "moderator.card.modal.paymentsTable.note": "Izoh",
  "moderator.card.modal.paymentsTable.recordedBy": "Kim tomonidan qabul qilingan",
  "moderator.card.modal.paymentsEmpty": "Hozircha to'lovlar yo'q",
  "moderator.card.modal.paymentAmount": "To'lov miqdori",
  "moderator.card.modal.paymentMethod": "To'lov usuli",
  "moderator.card.modal.paymentMethod.cash": "Naqd pul",
  "moderator.card.modal.paymentMethod.card": "Karta orqali",
  "moderator.card.modal.paymentMethod.transfer": "O'tkazma",
  // Legacy keys for backward compatibility
  "moderator.card.modal.paymentMethod.click": "Click",
  "moderator.card.modal.paymentMethod.payme": "Payme",
  "moderator.card.modal.paymentMethod.other": "Boshqa",
  "moderator.card.modal.paymentNote": "Izoh (ixtiyoriy)",
  "moderator.card.modal.paymentNotePlaceholder": "Masalan: birinchi to'lov qismi",
  "moderator.card.modal.confirmFullPayment": "To'liq to'langan",
  "moderator.card.modal.acceptPartialPayment": "Qisman to'lovni qabul qilish",
  "moderator.card.modal.paymentValidation.amountRequired": "Noto'g'ri miqdor",
  "moderator.card.modal.paymentValidation.amountRequiredDesc": "Noldan katta miqdorni kiriting",
  "moderator.card.modal.paymentValidation.amountExceeds": "Miqdor qoldiqdan oshib ketdi",
  "moderator.card.modal.paymentValidation.methodRequired": "To'lov usuli",
  "moderator.card.modal.paymentValidation.methodRequiredDesc": "To'lov usulini tanlang",
  "moderator.card.modal.paymentSuccess": "To'lov qabul qilindi",
  "moderator.card.modal.paymentError": "To'lov xatosi",
  "moderator.errors.loadCards": "Kartalarni yuklab bo'lmadi",
  "moderator.errors.loadItems": "Karta pozitsiyalarini yuklab bo'lmadi",
  "moderator.errors.loadPayments": "To'lovlarni yuklab bo'lmadi",
  "moderator.errors.loadVisits": "Tashriflarni yuklab bo'lmadi",
  "moderator.errors.loadClients": "Mijozlarni yuklab bo'lmadi",
  "moderator.errors.loadRequests": "So'rovlarni yuklab bo'lmadi",
  "moderator.errors.updatePhoto": "Fotoni yangilab bo'lmadi",
  "moderator.errors.updatePhotoDesc": "Fotoni yangilab bo'lmadi",
  "moderator.photo.updated": "Foto yangilandi",
  "moderator.kpi.quantityGreaterThanZero": "miqdor > 0",
  "moderator.select.loading": "Yuklanmoqda…",
  "moderator.select.client": "Mijozni tanlang",
  "moderator.select.doctor": "Shifokorni tanlang",
  "moderator.select.pet": "Hayvonni tanlang",

  // Client dashboard - Nurse Care tab
  "client.tabs.nurseCare": "Hamshira kartalari",
  "client.tabs.nurseCareShort": "Kartalar",
  "client.tabs.historyCards": "Tarix kartalari",
  "client.tabs.historyCardsShort": "Tarix",

  // Nurse dashboard - Nurse Care tab
  "nurse.tabs.nurseCare": "Nurse Care 💗",
  "nurse.tabs.nurseCareShort": "Nurse 💗",
  "nurse.medicines.itemFallback": "Pozitsiya #{{id}}",
  "nurse.medicines.untitled": "Nomsiz",

  // Admin dashboard
  "admin.banner.goHome": "Bosh sahifaga qaytish",
  "admin.message.useAdminPanel": "Tizimni boshqarish uchun ELVET administrator panelidan foydalaning.",
  "admin.message.urlNotConfigured": "Administrator panel URL sozlanmagan. Dasturchiga murojaat qiling.",
  "admin.button.openAdmin": "ELVET ADMIN",

  // Doctor dashboard - feed recommendation placeholder
  "doctor.feed.recommendationPlaceholder": "Masalan: JOSERA Catelux, 0.5 kg kuniga 14 kun uchun",
  "doctor.edit.attachments.add": "Ilovalarni qo'shish",

  // Client PetsManager - animal type labels
  "client.pets.animalType.dog": "🐕 It",
  "client.pets.animalType.cat": "🐈 Mushuk",
  "client.pets.animalType.bird": "🦜 Qush",
  "client.pets.animalType.other": "🐾 Boshqa",
  "client.pets.colorPlaceholder": "Jigar rang",
  "client.pets.descriptionPlaceholder": "Xususiyatlar, allergiyalar...",

  // Client MedicalCardsViewer - column headers and labels
  "client.medicalCards.column.waiting": "To'lovni kutmoqda",
  "client.medicalCards.column.partlyPaid": "Qisman to'langan",
  "client.medicalCards.column.fullyPaid": "To'liq to'langan",
  "client.medicalCards.currency.sum": "so'm",
  "client.medicalCards.attachments": "Ilovalar",
  "client.medicalCards.attachments.downloadAll": "Hammasini yuklab olish",
  "client.medicalCards.attachments.download": "Yuklab olish",
  "client.medicalCards.attachments.xrays": "Rentgen suratlari",
  "client.medicalCards.attachments.files": "Fayllar",
  "client.medicalCards.attachments.open": "Ochish",
  "client.medicalCards.attachments.openFile": "Ochish",

  // Client NurseCareCardsViewer
  "client.nurseCare.title": "Hamshira kartalari",
  "client.nurseCare.subtitle": "Hamshira parvarish tarixini ko'rish",
  "client.nurseCare.loading": "Yuklanmoqda…",
  "client.nurseCare.error": "Yuklab bo'lmadi",
  "client.nurseCare.empty": "Hozircha parvarish kartalari yo'q",
  "client.nurseCare.column.waiting": "To'lovni kutmoqda",
  "client.nurseCare.column.partlyPaid": "Qisman to'langan",
  "client.nurseCare.column.fullyPaid": "To'liq to'langan",
  "client.nurseCare.status.waiting": "To'lovni kutmoqda",
  "client.nurseCare.status.partlyPaid": "Qisman to'langan",
  "client.nurseCare.status.fullyPaid": "To'liq to'langan",
  "client.nurseCare.cardNumber": "Karta #{{id}}",
  "client.nurseCare.nurseNumber": "Hamshira #{{id}}",
  "client.nurseCare.servicesEmpty": "Xizmatlar yo'q",
  "client.nurseCare.total": "Jami:",
  "client.nurseCare.paid": "To'langan:",
  "client.nurseCare.remain": "Qoldiq:",

  // Client HistoryCardsViewer (unified medical + nurse cards)
  "client.historyCards.title": "Tarix kartalari",
  "client.historyCards.subtitle": "Barcha tibbiy va parvarish kartalari bir joyda",
  "client.historyCards.filterByStatus": "To'lov holatiga ko'ra filtrlash",
  "client.historyCards.status.waiting": "To'lovni kutmoqda",
  "client.historyCards.status.waitingShort": "Kutish",
  "client.historyCards.status.partlyPaid": "Qisman to'langan",
  "client.historyCards.status.partlyPaidShort": "Qisman",
  "client.historyCards.status.fullyPaid": "To'liq to'langan",
  "client.historyCards.status.fullyPaidShort": "To'liq",
  "client.historyCards.badge.medical": "Tibbiy",
  "client.historyCards.badge.medicalShort": "Tib",
  "client.historyCards.badge.nurseCare": "Parvarish",
  "client.historyCards.badge.nurseCareShort": "Parv",
  "client.historyCards.empty": "Kartalar topilmadi",
  "client.historyCards.emptyHint": "Boshqa to'lov holatini tanlang",

  // Moderator NurseCareCardsManager
  "moderator.nurseCare.title": "Hamshira parvarish kartalari",
  "moderator.nurseCare.description": "Kartalar yarating va to'lovlarni yozib oling.",
  "moderator.nurseCare.allCards": "Barcha kartalar",
  "moderator.nurseCare.refresh": "Yangilash",
  "moderator.nurseCare.loading": "Yuklanmoqda…",
  "moderator.nurseCare.noCards": "Kartalar yo'q",
  "moderator.nurseCare.cardNumber": "Karta #{{id}}",
  "moderator.nurseCare.paidInfo": "To'langan {{paid}} / {{total}} · Qoldiq {{remain}}",
  "moderator.nurseCare.createCard": "Karta yaratish",
  "moderator.nurseCare.client": "Mijoz",
  "moderator.nurseCare.selectClient": "Mijozni tanlang",
  "moderator.nurseCare.pet": "Hayvon",
  "moderator.nurseCare.selectPet": "Hayvonni tanlang",
  "moderator.nurseCare.nurse": "Hamshira",
  "moderator.nurseCare.selectNurse": "Hamshirani tanlang",
  "moderator.nurseCare.descriptionLabel": "Tavsif",
  "moderator.nurseCare.descriptionPlaceholder": "Ixtiyoriy",
  "moderator.nurseCare.create": "Yaratish",
  "moderator.nurseCare.recordPayment": "To'lovni yozib olish",
  "moderator.nurseCare.selectCardMessage": "To'lovni yozib olish uchun kartani tanlang.",
  "moderator.nurseCare.total": "Jami:",
  "moderator.nurseCare.paid": "To'langan:",
  "moderator.nurseCare.remain": "Qoldiq:",
  "moderator.nurseCare.amount": "Miqdor",
  "moderator.nurseCare.amountPlaceholder": "masalan, 40000",
  "moderator.nurseCare.method": "Usul",
  "moderator.nurseCare.selectMethod": "Usulni tanlang",
  "moderator.nurseCare.record": "Yozib olish",
  "moderator.nurseCare.errors.loadFailed": "Kartalarni yuklab bo'lmadi",
  "moderator.nurseCare.errors.missingFields": "Maydonlar to'ldirilmagan",
  "moderator.nurseCare.errors.selectClientPetNurse": "Mijoz va hamshirani tanlang",
  "moderator.nurseCare.success.created": "Yaratildi",
  "moderator.nurseCare.success.createdDesc": "Hamshira parvarish kartasi yaratildi",
  "moderator.nurseCare.errors.createFailed": "Yaratib bo'lmadi",
  "moderator.nurseCare.errors.enterAmountMethod": "Miqdor va usulni kiriting",
  "moderator.nurseCare.success.recorded": "Yozib olindi",
  "moderator.nurseCare.success.recordedDesc": "To'lov yozib olindi",
  "moderator.nurseCare.errors.recordFailed": "To'lovni yozib bo'lmadi",

  // Client ProfileEditor - phone placeholder
  "client.profile.phonePlaceholder": "+998 90 123 45 67",
  "client.profile.nameSeparator": ":",

  // Moderator sidebar navigation
  "moderator.sidebar.navigation": "Navigatsiya",
  "moderator.sidebar.main": "Bosh sahifa",
  "moderator.sidebar.medicalCards": "Tibbiy kartalar",
  "moderator.sidebar.visits": "Tashriflar",
  "moderator.sidebar.requests": "So'rovlar",
  "moderator.sidebar.clients": "Mijozlar",
  "moderator.sidebar.addClient": "Mijoz qo'shish",
  "moderator.sidebar.nurseCare": "Hamshira parvarishi",
  "moderator.sidebar.feedSales": "Oziq-ovqat sotuvi",
  "moderator.sidebar.feedInventory": "Oziq-ovqat ombori",
  "moderator.sidebar.medicines": "Dori ombori",
  "moderator.sidebar.staffIncome": "Xodimlar daromadi",
  "moderator.sidebar.collapse": "Yig'ish",
  "moderator.sidebar.expand": "Yoyish",
  "moderator.sidebar.hint": "Qabul paneli",

  // Moderator staff income dashboard
  "moderator.staffIncome.title": "Xodimlar daromadi va to'lovlari",
  "moderator.staffIncome.description": "Shifokorlar va hamshiralarning kunlik daromadi",
  "moderator.staffIncome.date": "Sana",
  "moderator.staffIncome.search": "Qidirish",
  "moderator.staffIncome.searchPlaceholder": "Ism yoki ID bo'yicha qidirish...",
  "moderator.staffIncome.filterRole": "Lavozim bo'yicha filtrlash",
  "moderator.staffIncome.allRoles": "Barcha lavozimlar",
  "moderator.staffIncome.doctors": "Shifokorlar",
  "moderator.staffIncome.nurses": "Hamshiralar",
  "moderator.staffIncome.refresh": "Yangilash",
  "moderator.staffIncome.go": "Qo'llash",
  "moderator.staffIncome.totalStaff": "Jami xodimlar",
  "moderator.staffIncome.totalEarned": "Umumiy daromad",
  "moderator.staffIncome.paidOut": "To'langan",
  "moderator.staffIncome.pendingPay": "To'lovni kutmoqda",
  "moderator.staffIncome.col.id": "ID",
  "moderator.staffIncome.col.name": "Ism",
  "moderator.staffIncome.col.role": "Lavozim",
  "moderator.staffIncome.col.earned": "Topilgan",
  "moderator.staffIncome.col.status": "Holat",
  "moderator.staffIncome.col.action": "Harakat",
  "moderator.staffIncome.role.doctor": "Shifokor",
  "moderator.staffIncome.role.nurse": "Hamshira",
  "moderator.staffIncome.status.paid": "To'langan",
  "moderator.staffIncome.status.unpaid": "To'lanmagan",
  "moderator.staffIncome.pay": "To'lash",
  "moderator.staffIncome.paying": "To'lanmoqda...",
  "moderator.staffIncome.alreadyPaid": "To'langan",
  "moderator.staffIncome.empty.noData": "Bu sana uchun ish haqi ma'lumotlari yo'q",
  "moderator.staffIncome.empty.noMatch": "Filtrlaringizga mos xodimlar yo'q",
  "moderator.staffIncome.paySuccess": "To'lov yozib olindi",
  "moderator.staffIncome.payError": "To'lov xatosi",
  "moderator.staffIncome.loadError": "Ma'lumotlarni yuklab bo'lmadi",

  // Medicine storage
  "storage.title": "Dori-darmon ombori",
  "storage.adminIntro": "Kirim, hisobdan chiqarish, inventarizatsiya va narxlar. Shifokorlar ishlatgan hamma narsa ombordan avtomatik chiqariladi.",
  "storage.subtitleView": "Hozir omborda nima bor",
  "storage.add": "Dori qo'shish",
  "storage.searchPlaceholder": "Dori qidirish…",
  "storage.loadError": "Omborni yuklab bo'lmadi",
  "storage.retry": "Qayta urinish",
  "storage.note": "Izoh",
  "storage.summary.total": "Jami pozitsiyalar",
  "storage.summary.out": "Mavjud emas",
  "storage.summary.low": "Tugab bormoqda",
  "storage.summary.expiring": "≤ {{days}} kunda tugaydi",
  "storage.summary.expired": "Muddati o'tganlar bor",
  "storage.summary.noPrice": "Narxsiz",
  "storage.filter.allTypes": "Barcha turlar",
  "storage.filter.showInactive": "Nofaollarni ko'rsatish",
  "storage.table.name": "Dori",
  "storage.table.stock": "Mavjud",
  "storage.table.price": "Sotish narxi",
  "storage.table.expiry": "Eng yaqin muddat",
  "storage.table.actions": "Amallar",
  "storage.status.out": "Mavjud emas",
  "storage.status.low": "Kam qoldi",
  "storage.status.inactive": "Nofaol",
  "storage.status.noPrice": "Narx ko'rsatilmagan",
  "storage.status.expired": "Muddati o'tgan",
  "storage.status.expiredQty": "Muddati o'tgan: {{qty}}",
  "storage.actions.receive": "Kirim",
  "storage.actions.writeOff": "Hisobdan chiqarish",
  "storage.actions.count": "Inventarizatsiya",
  "storage.actions.history": "Tarix va partiyalar",
  "storage.actions.edit": "Tahrirlash",
  "storage.unit.PIECE": "dona",
  "storage.unit.TABLET": "tab.",
  "storage.unit.CAPSULE": "kaps.",
  "storage.unit.AMPOULE": "amp.",
  "storage.unit.SACHET": "pak.",
  "storage.unit.ML": "ml",
  "storage.unit.MG": "mg",
  "storage.unit.G": "g",
  "storage.unitName.PIECE": "Dona",
  "storage.unitName.TABLET": "Tabletka / kaplet",
  "storage.unitName.CAPSULE": "Kapsula",
  "storage.unitName.AMPOULE": "Ampula",
  "storage.unitName.SACHET": "Paketcha",
  "storage.unitName.ML": "Millilitr (ml)",
  "storage.unitName.MG": "Milligramm (mg)",
  "storage.unitName.G": "Gramm (g)",
  "storage.package.PIECE": "dona",
  "storage.package.PACK": "qadoq",
  "storage.package.BLISTER": "blister",
  "storage.package.VIAL": "flakon",
  "storage.package.BOTTLE": "shisha",
  "storage.package.TUBE": "tuba",
  "storage.packageName.PIECE": "Dona",
  "storage.packageName.PACK": "Qadoq / quti",
  "storage.packageName.BLISTER": "Blister",
  "storage.packageName.VIAL": "Flakon",
  "storage.packageName.BOTTLE": "Shisha",
  "storage.packageName.TUBE": "Tuba",
  "storage.form.createTitle": "Yangi dori",
  "storage.form.editTitle": "Dorini tahrirlash",
  "storage.form.subtitle": "Dori qanday sarflanishini tanlang — qoldiq hisobi va narx shunga bog'liq.",
  "storage.form.name": "Nomi",
  "storage.form.namePlaceholder": "Masalan: Sinuloks 50 mg",
  "storage.form.type": "Hisob turi",
  "storage.form.types.WHOLE.title": "Butun dona",
  "storage.form.types.WHOLE.hint": "Faqat butunligicha sotiladi: pasta, yoqa, shprits, sprey.",
  "storage.form.types.COUNTABLE.title": "Qadoqdagi donalar",
  "storage.form.types.COUNTABLE.hint": "Tabletka, kapsula, ampula. Qadoqning bir qismini sotish mumkin.",
  "storage.form.types.MEASURED.title": "Suyuq / vazn bo'yicha",
  "storage.form.types.MEASURED.hint": "ml, mg yoki g da hisob. Shifokor kerakli miqdorni oladi, qolgani qoladi.",
  "storage.form.unitLocked": "Omborda qoldiq yoki tarix bor ekan, tur va birlikni o'zgartirib bo'lmaydi.",
  "storage.form.unit": "Hisob birligi",
  "storage.form.packageUnit": "Qadoq",
  "storage.form.packageSize": "1 {{package}} da nechta {{unit}}",
  "storage.form.price": "Sotish narxi, so'm",
  "storage.form.pricePer": "Bu narx necha {{unit}} uchun",
  "storage.form.doseStep": "Eng kichik ulush",
  "storage.form.doseStepHint": "Shifokor shu qadamga karrali miqdor yozadi (masalan, ½ tabletka yoki 0.01 ml).",
  "storage.form.example": "Misol: shifokor {{qty}} ishlatadi → mijoz {{price}} to'laydi",
  "storage.form.minStock": "Qoldiq ≤ bo'lganda ogohlantirish ({{unit}})",
  "storage.form.minStockHint": "0 — ogohlantirishsiz",
  "storage.form.active": "Foydalanilmoqda",
  "storage.form.description": "Tavsif",
  "storage.form.errorName": "Nomini kiriting",
  "storage.form.errorPrice": "Narxni kiriting",
  "storage.form.created": "Dori qo'shildi",
  "storage.form.updated": "O'zgarishlar saqlandi",
  "storage.form.saveError": "Saqlab bo'lmadi",
  "storage.receive.title": "Omborga kirim",
  "storage.receive.packages": "Butun {{package}} ({{size}} dan)",
  "storage.receive.quantity": "Miqdori, {{unit}}",
  "storage.receive.loose": "Alohida qo'shimcha, {{unit}}",
  "storage.receive.total": "Qo'shiladi",
  "storage.receive.expireDate": "Yaroqlilik muddati",
  "storage.receive.batchNumber": "Seriya / partiya",
  "storage.receive.purchasePrice": "{{package}} uchun xarid narxi",
  "storage.receive.submit": "Kirim qilish",
  "storage.receive.done": "{{qty}} qo'shildi",
  "storage.receive.error": "Kirim qilib bo'lmadi",
  "storage.receive.errorEmpty": "Miqdorni kiriting",
  "storage.writeOff.title": "Hisobdan chiqarish",
  "storage.writeOff.batch": "Partiya",
  "storage.writeOff.batchAuto": "Avtomatik (avval eskilari)",
  "storage.writeOff.batchOption": "{{expiry}} gacha — {{qty}}",
  "storage.writeOff.quantity": "Miqdori, {{unit}}",
  "storage.writeOff.reason": "Sabab",
  "storage.writeOff.submit": "Hisobdan chiqarish",
  "storage.writeOff.done": "{{qty}} hisobdan chiqarildi",
  "storage.writeOff.error": "Hisobdan chiqarib bo'lmadi",
  "storage.reason.EXPIRED": "Muddati o'tgan",
  "storage.reason.DAMAGED": "Shikastlangan / singan",
  "storage.reason.LOST": "Yo'qolgan",
  "storage.reason.OTHER": "Boshqa",
  "storage.adjust.title": "Inventarizatsiya",
  "storage.adjust.subtitle": "{{name}} ni javonda sanab, haqiqiy qoldiqni kiriting.",
  "storage.adjust.inSystem": "Tizim bo'yicha",
  "storage.adjust.counted": "Haqiqatda, {{unit}}",
  "storage.adjust.difference": "Farq: {{qty}}",
  "storage.adjust.noDifference": "Farq yo'q",
  "storage.adjust.done": "Qoldiq to'g'rilandi",
  "storage.adjust.error": "Saqlab bo'lmadi",
  "storage.history.batches": "Partiyalar",
  "storage.history.journal": "Harakatlar jurnali",
  "storage.history.noBatches": "Qoldiq yo'q",
  "storage.history.noMovements": "Hozircha harakat yo'q",
  "storage.history.received": "Kelgan sana",
  "storage.history.expiry": "Yaroqlilik",
  "storage.history.remaining": "Qoldi / bor edi",
  "storage.history.cost": "Xarid",
  "storage.history.when": "Qachon",
  "storage.history.operation": "Amal",
  "storage.history.quantity": "Miqdor",
  "storage.history.details": "Tafsilotlar",
  "storage.history.who": "Kim",
  "storage.history.card": "Karta №{{id}}",
  "storage.kind.RECEIPT": "Kirim",
  "storage.kind.DISPENSE": "Ishlatildi",
  "storage.kind.RETURN": "Qaytarildi",
  "storage.kind.WRITE_OFF": "Hisobdan chiqarildi",
  "storage.kind.ADJUSTMENT": "Inventarizatsiya",
  "storage.dose.add": "Dori qo'shish",
  "storage.dose.noLines": "Dorilar qo'shilmagan",
  "storage.dose.inStock": "Omborda",
  "storage.dose.notePlaceholder": "Qanday qo'llash (m/i, kuniga 2 marta…)",
  "storage.dose.total": "Dorilar jami",
  "storage.dose.errorPositive": "Noldan katta miqdor kiriting",
  "storage.dose.errorStep": "Miqdor {{step}} ga karrali bo'lishi kerak",
  "storage.dose.errorStock": "Omborda faqat {{available}}",
  "storage.dose.errorNoPrice": "Dori narxi ko'rsatilmagan",
  "storage.dose.fixErrors": "Dorilarni tekshiring",
  "storage.dose.saveFailed": "Barcha dorilar saqlanmadi",

  // Admin panel
  "adminPanel.title": "Administrator paneli",
  "adminPanel.menu": "Menyu",
  "adminPanel.refresh": "Yangilash",
  "adminPanel.refreshing": "Yangilanmoqda…",
  "adminPanel.group.main": "Asosiy",
  "adminPanel.group.money": "Pul",
  "adminPanel.group.people": "Odamlar",
  "adminPanel.group.catalog": "Ombor va narxlar",
  "adminPanel.nav.overview": "Umumiy ko'rinish",
  "adminPanel.nav.cards": "Tibbiy kartalar",
  "adminPanel.nav.finance": "Moliya",
  "adminPanel.nav.salaries": "Ish haqi",
  "adminPanel.nav.staff": "Xodimlar",
  "adminPanel.nav.clients": "Mijozlar",
  "adminPanel.nav.requests": "Saytdan arizalar",
  "adminPanel.nav.storage": "Dori ombori",
  "adminPanel.nav.services": "Xizmatlar va narxlar",
  "adminPanel.nav.stationary": "Statsionar",
  "adminPanel.nav.feeds": "Ozuqalar",
  "adminPanel.nav.doctor": "Shifokor kabineti",
  "adminPanel.nav.django": "Kengaytirilgan admin",
  "adminPanel.common.add": "Qo'shish",
  "adminPanel.common.edit": "Tahrirlash",
  "adminPanel.common.actions": "Amallar",
  "adminPanel.common.search": "Qidirish…",
  "adminPanel.common.total": "Jami: {{count}}",
  "adminPanel.common.loadError": "Ma'lumotlarni yuklab bo'lmadi",
  "adminPanel.common.saved": "Saqlandi",
  "adminPanel.common.saveError": "Saqlab bo'lmadi",
  "adminPanel.common.deleted": "O'chirildi",
  "adminPanel.common.deleteError": "O'chirib bo'lmadi",
  "adminPanel.common.deleteTitle": "Yozuvni o'chirasizmi?",
  "adminPanel.common.deleteText": "Bu amalni bekor qilib bo'lmaydi.",
  "adminPanel.common.required": "«{{field}}» maydonini to'ldiring",
  "adminPanel.common.passwordKeep": "O'zgartirmaslik uchun bo'sh qoldiring",
  "adminPanel.common.on": "Faol",
  "adminPanel.common.off": "O'chirilgan",
  "adminPanel.fields.name": "Nomi / ismi",
  "adminPanel.fields.firstName": "Ism",
  "adminPanel.fields.lastName": "Familiya",
  "adminPanel.fields.phone": "Telefon",
  "adminPanel.fields.extraPhone": "Qo'shimcha telefon",
  "adminPanel.fields.password": "Parol",
  "adminPanel.fields.passwordHint": "Kamida 6 belgi. Tahrirlashda — yangi parol.",
  "adminPanel.fields.status": "Holati",
  "adminPanel.fields.specialization": "Mutaxassislik",
  "adminPanel.fields.experience": "Tajriba, yil",
  "adminPanel.fields.workStart": "Ish boshlagan sana",
  "adminPanel.fields.fixedSalary": "Belgilangan maosh",
  "adminPanel.fields.description": "Tavsif",
  "adminPanel.fields.address": "Manzil",
  "adminPanel.fields.registered": "Ro'yxatdan o'tgan",
  "adminPanel.fields.price": "Narx",
  "adminPanel.fields.date": "Sana",
  "adminPanel.fields.doctor": "Shifokor",
  "adminPanel.overview.period": "Davr",
  "adminPanel.overview.days": "{{count}} kun",
  "adminPanel.overview.income": "Davr daromadi",
  "adminPanel.overview.expenses": "Davr xarajatlari",
  "adminPanel.overview.net": "Sof foyda",
  "adminPanel.overview.unpaid": "Mijozlar qarzi",
  "adminPanel.overview.cards": "Tibbiy kartalar",
  "adminPanel.overview.newClients": "Yangi mijozlar",
  "adminPanel.overview.today": "Bugun: {{value}}",
  "adminPanel.overview.thisMonth": "Shu oyda: {{value}}",
  "adminPanel.overview.unpaidCards": "To'lanmagan kartalar: {{count}}",
  "adminPanel.overview.todayCount": "Bugun: {{count}}",
  "adminPanel.overview.clientsTotal": "Jami mijozlar: {{count}}",
  "adminPanel.overview.attention": "E'tibor talab qiladi:",
  "adminPanel.overview.alertOut": "Mavjud emas: {{count}}",
  "adminPanel.overview.alertLow": "Tugab bormoqda: {{count}}",
  "adminPanel.overview.alertExpiring": "Muddati tugayapti: {{count}}",
  "adminPanel.overview.alertUnpaid": "To'lanmagan kartalar: {{count}}",
  "adminPanel.overview.alertRequests": "Arizalar: {{count}}",
  "adminPanel.overview.dailyTitle": "Kunlik daromad va xarajatlar",
  "adminPanel.overview.dailyHint": "Klinikaning barcha tushumlari va yozilgan xarajatlar",
  "adminPanel.overview.monthlyTitle": "So'nggi 12 oy",
  "adminPanel.overview.monthlyHint": "Oylik daromad va xarajatlar",
  "adminPanel.overview.cardsTitle": "Kunlik tibbiy kartalar",
  "adminPanel.overview.cardsHint": "Har kuni nechta qabul bo'lgan",
  "adminPanel.overview.methodsTitle": "To'lov usullari",
  "adminPanel.overview.methodsHint": "Davr uchun karta va parvarish to'lovlari",
  "adminPanel.overview.servicesTitle": "Eng daromadli xizmatlar",
  "adminPanel.overview.servicesHint": "Davr bo'yicha top-8",
  "adminPanel.overview.medicinesTitle": "Eng ko'p ishlatilgan dorilar",
  "adminPanel.overview.medicinesHint": "Davr tushumi bo'yicha",
  "adminPanel.overview.doctorsTitle": "Shifokorlar ishi",
  "adminPanel.overview.doctorsHint": "Davr uchun kartalar, hisoblar va shifokor daromadi",
  "adminPanel.overview.revenue": "Tushum",
  "adminPanel.overview.earned": "Shifokor topgan",
  "adminPanel.overview.used": "Ishlatilgan",
  "adminPanel.overview.noData": "Davr uchun ma'lumot yo'q",
  "adminPanel.cards.hint": "Klinikaning barcha kartalari. Kartani ochish va to'lov qabul qilish uchun qatorni bosing.",
  "adminPanel.cards.search": "Qidirish: №, mijoz, hayvon, shifokor",
  "adminPanel.cards.allStatuses": "Barcha holatlar",
  "adminPanel.cards.status.OPEN": "Ochiq",
  "adminPanel.cards.status.WAITING_FOR_PAYMENT": "To'lov kutilmoqda",
  "adminPanel.cards.status.PARTLY_PAID": "Qisman to'langan",
  "adminPanel.cards.status.FULLY_PAID": "To'langan",
  "adminPanel.cards.card": "Karta",
  "adminPanel.cards.client": "Mijoz",
  "adminPanel.cards.pet": "Uy hayvoni",
  "adminPanel.cards.total": "Summa",
  "adminPanel.cards.debt": "Qarz",
  "adminPanel.cards.services": "Xizmatlar",
  "adminPanel.cards.medicines": "Dorilar",
  "adminPanel.cards.stationary": "Statsionar",
  "adminPanel.cards.anamnez": "Anamnez",
  "adminPanel.cards.diagnosis": "Tashxis",
  "adminPanel.cards.prescriptions": "Tayinlovlar",
  "adminPanel.cards.payments": "To'lovlar",
  "adminPanel.cards.noPayments": "Hozircha to'lov yo'q",
  "adminPanel.cards.paidSoFar": "To'langan",
  "adminPanel.cards.receive": "To'lov qabul qilish",
  "adminPanel.cards.receiveButton": "Qabul qilish",
  "adminPanel.cards.paid": "{{amount}} qabul qilindi",
  "adminPanel.cards.payError": "To'lovni qabul qilib bo'lmadi",
  "adminPanel.finance.day": "Kun",
  "adminPanel.finance.month": "Oy",
  "adminPanel.finance.year": "Yil",
  "adminPanel.finance.income": "Daromad",
  "adminPanel.finance.expenses": "Xarajatlar",
  "adminPanel.finance.net": "Sof foyda",
  "adminPanel.finance.expensesTab": "Xarajatlar",
  "adminPanel.finance.paymentsTab": "To'lovlar tarixi",
  "adminPanel.finance.expensesHint": "Ijara, kommunal, xaridlar. Ish haqi to'langanda avtomatik qo'shiladi.",
  "adminPanel.finance.paymentsHint": "Tibbiy kartalar bo'yicha barcha to'lovlar",
  "adminPanel.finance.addExpense": "Xarajat qo'shish",
  "adminPanel.finance.amount": "Summa",
  "adminPanel.finance.categoryLabel": "Toifa",
  "adminPanel.finance.methodLabel": "To'lov usuli",
  "adminPanel.finance.note": "Izoh",
  "adminPanel.finance.method.CASH": "Naqd",
  "adminPanel.finance.method.CARD": "Karta",
  "adminPanel.finance.method.TRANSFER": "O'tkazma",
  "adminPanel.finance.category.SALARY": "Ish haqi",
  "adminPanel.finance.category.MEDICINE": "Dori xaridi",
  "adminPanel.finance.category.FEED": "Ozuqa xaridi",
  "adminPanel.finance.category.RENT": "Ijara",
  "adminPanel.finance.category.UTILITIES": "Kommunal",
  "adminPanel.finance.category.EQUIPMENT": "Jihozlar",
  "adminPanel.finance.category.OTHER": "Boshqa",
  "adminPanel.staff.doctors": "Shifokorlar",
  "adminPanel.staff.nurses": "Hamshiralar",
  "adminPanel.staff.moderators": "Qabulxona xodimlari",
  "adminPanel.staff.hint": "Ishdan ketgan xodimga kirishni yopish uchun «Kira oladi»ni o'chiring.",
  "adminPanel.staff.addDoctor": "Shifokor qo'shish",
  "adminPanel.staff.addNurse": "Hamshira qo'shish",
  "adminPanel.staff.addModerator": "Qabulxona xodimini qo'shish",
  "adminPanel.staff.active": "Ishlamoqda",
  "adminPanel.staff.inactive": "Kirish yopilgan",
  "adminPanel.staff.vacation": "Ta'tilda",
  "adminPanel.staff.canLogin": "Kira oladi",
  "adminPanel.staff.onVacation": "Ta'tilda",
  "adminPanel.staff.earnedToday": "Bugun topgan",
  "adminPanel.clients.hint": "Uy hayvonlari egalari. Parolni tahrirlashda o'zgartirish mumkin.",
  "adminPanel.clients.add": "Mijoz qo'shish",
  "adminPanel.services.hint": "Xizmatlar narxi va har bir xizmatdan shifokor / hamshira ulushi.",
  "adminPanel.services.add": "Xizmat qo'shish",
  "adminPanel.services.doctorShare": "Shifokor ulushi",
  "adminPanel.services.nurseShare": "Hamshira ulushi",
  "adminPanel.services.sharePercent": "Shifokor ulushi, %",
  "adminPanel.services.shareFixed": "Yoki shifokorga belgilangan summa",
  "adminPanel.services.shareHint": "Agar % ko'rsatilgan bo'lsa, foiz ishlatiladi.",
  "adminPanel.services.nursePercent": "Hamshira ulushi, %",
  "adminPanel.services.rates": "Shifokor stavkalari",
  "adminPanel.services.ratesTitle": "Shaxsiy stavkalar: {{name}}",
  "adminPanel.services.ratesHint": "Odatda shifokor {{share}} oladi. Bu yerda alohida shifokor uchun boshqa ulush belgilash mumkin.",
  "adminPanel.stationary.hint": "Shifokor kartada tanlaydigan statsionar tariflari.",
  "adminPanel.stationary.add": "Tarif qo'shish",
  "adminPanel.stationary.period": "Muddat",
  "adminPanel.stationary.amount": "Davomiyligi",
  "adminPanel.stationary.unit": "Birlik",
  "adminPanel.stationary.hour": "soat",
  "adminPanel.stationary.day": "kun",
  "adminPanel.feeds.hint": "Qabulxona sotadigan ozuqalar. Sotilganda kg qoldiq kamayadi.",
  "adminPanel.feeds.add": "Ozuqa qo'shish",
  "adminPanel.feeds.brand": "Brend",
  "adminPanel.feeds.product": "Mahsulot",
  "adminPanel.feeds.factory": "Ishlab chiqaruvchi",
  "adminPanel.feeds.animal": "Hayvon",
  "adminPanel.feeds.age": "Yosh",
  "adminPanel.feeds.dog": "It",
  "adminPanel.feeds.cat": "Mushuk",
  "adminPanel.feeds.junior": "Yosh",
  "adminPanel.feeds.adult": "Katta",
  "adminPanel.feeds.senior": "Keksa",
  "adminPanel.feeds.packageKg": "Qadoq og'irligi, kg",
  "adminPanel.feeds.pricePerKg": "1 kg narxi",
  "adminPanel.feeds.inStock": "Qoldiq",
  "adminPanel.feeds.inStockKg": "Qoldiq, kg",
  "adminPanel.requests.hint": "Sayt formasi orqali yuborilgan arizalar.",
  "adminPanel.requests.message": "Xabar",
  "storage.currency": "so'm",
  "storage.form.stepWhat": "Bu qanday dori",
  "storage.form.stepPackage": "Qadoq",
  "storage.form.stepPrice": "Sotish narxi",
  "storage.form.stepInitial": "Hozir qancha keldi",
  "storage.form.initialHint": "Ixtiyoriy. Dori javonda bo'lsa — miqdorini kiriting, u darhol omborda paydo bo'ladi.",
  "storage.form.stepOther": "Qo'shimcha",
  "storage.form.initialFailed": "Dori qo'shildi, lekin qoldiq saqlanmadi — «Kirim»ni bosing",

  // Feed sales
  "feedSales.title": "Ozuqa sotish",
  "feedSales.subtitle": "Ozuqani istalgan xaridorga soting — klinika mijoziga yoki tashqaridan kelganga.",
  "feedSales.new": "Yangi sotuv",
  "feedSales.newTitle": "Ozuqa sotuvi",
  "feedSales.newHint": "Xaridorni, nima olayotganini va qanday to'lashini kiriting. Summa avtomatik hisoblanadi.",
  "feedSales.buyer": "Xaridor",
  "feedSales.mode.walkin": "Tashqaridan xaridor",
  "feedSales.mode.walkinHint": "Klinika mijozi emas — faqat ism va familiya kerak. To'lov darhol.",
  "feedSales.mode.client": "Klinika mijozi",
  "feedSales.mode.clientHint": "Ro'yxatdan o'tgan mijoz. Keyinroq to'lash mumkin.",
  "feedSales.firstName": "Ism",
  "feedSales.lastName": "Familiya",
  "feedSales.pickClient": "Mijozni tanlang…",
  "feedSales.searchClient": "Ism yoki telefon",
  "feedSales.whatBought": "Nima sotib olindi",
  "feedSales.feed": "Ozuqa",
  "feedSales.pickFeed": "Ozuqani tanlang",
  "feedSales.left": "qoldi {{kg}}",
  "feedSales.kg": "Miqdori, kg",
  "feedSales.package": "qadoq {{kg}}",
  "feedSales.addLine": "Yana ozuqa qo'shish",
  "feedSales.payment": "To'lov",
  "feedSales.pay.CASH": "Naqd",
  "feedSales.pay.CARD": "Karta",
  "feedSales.pay.TRANSFER": "O'tkazma",
  "feedSales.pay.LATER": "Keyinroq to'laydi",
  "feedSales.total": "Jami",
  "feedSales.sell": "Sotish — {{amount}}",
  "feedSales.saveDebt": "Saqlash (qarzga)",
  "feedSales.created": "Sotuv saqlandi",
  "feedSales.paidDone": "{{amount}} to'landi",
  "feedSales.tabAll": "Barcha sotuvlar",
  "feedSales.tabUnpaid": "To'lanmagan ({{count}})",
  "feedSales.empty": "Hozircha sotuv yo'q",
  "feedSales.date": "Sana",
  "feedSales.statusLabel": "Holati",
  "feedSales.status.PAID": "To'langan",
  "feedSales.status.PARTLY_PAID": "Qisman",
  "feedSales.status.WAITING": "To'lanmagan",
  "feedSales.receive": "To'lov qabul qilish",
  "feedSales.payTitle": "To'lov: {{name}}",
  "feedSales.remaining": "To'lash kerak: {{amount}}",
  "feedSales.amount": "Summa",
  "feedSales.errors.name": "Xaridor ismini kiriting",
  "feedSales.errors.client": "Mijozni tanlang",
  "feedSales.errors.items": "Kamida bitta ozuqa va miqdor kiriting",
  "feedSales.errors.fixItems": "Ozuqa miqdorini tuzating",
  "feedSales.errors.pay": "To'lov usulini tanlang",
  "feedSales.errors.kg": "Miqdor noldan katta bo'lishi kerak",
  "feedSales.errors.stock": "Omborda faqat {{kg}}",
  "feedSales.errors.save": "Sotuvni saqlab bo'lmadi",
};
